module.exports = __webpack_public_path__ + "media/images/page/about02-8fef5f8eecf7ecb0d9e608286c78a161.jpg";